export default __webpack_public_path__ + "static/Maurice_blue-1c1d785bb165b4637705989e33b8def2.png";